<nb-auth-block>
  <nb-card>
    <nb-card-body>
      <h1 class="title">Create an account</h1>
      <p class="subtitle">Enter your information to register.</p>
      <form [formGroup]="registerForm" (submit)="onSubmit()">
        <div class="form-group">
          <div>Role : {{ role }}</div>
        </div>
        <div class="form-group">
          <label for="email"
            >Email address <span class="text-danger"> *</span></label
          >
          <input
            type="email"
            class="form-control"
            id="email"
            formControlName="email"
            disabled
          />
          <div
            *ngIf="
              registerForm.get('email').invalid &&
              (registerForm.get('email').dirty ||
                registerForm.get('email').touched)
            "
            class="alert alert-danger"
          >
            <div *ngIf="registerForm.get('email').errors.required">
              Email is required.
            </div>
            <div *ngIf="registerForm.get('email').errors.email">
              Invalid email format.
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="password"
            >Password <span class="text-danger"> *</span></label
          >
          <input
            type="password"
            class="form-control"
            id="password"
            formControlName="password"
          />
          <div
            *ngIf="
              registerForm.get('password').invalid &&
              (registerForm.get('password').dirty ||
                registerForm.get('password').touched)
            "
            class="alert alert-danger"
          >
            <div *ngIf="registerForm.get('password').errors.required">
              Password is required.
            </div>
            <div *ngIf="registerForm.get('password').errors.minlength">
              Password should have 8 characters.
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="username"
            >Username <span class="text-danger"> *</span></label
          >
          <input
            type="text"
            class="form-control"
            id="username"
            formControlName="username"
          />
          <div
            *ngIf="
              registerForm.get('username').invalid &&
              (registerForm.get('username').dirty ||
                registerForm.get('username').touched)
            "
            class="alert alert-danger"
          >
            <div *ngIf="registerForm.get('username').errors.required">
              Username is required.
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="firstName">First name</label>
          <input
            type="text"
            class="form-control"
            id="firstName"
            formControlName="firstName"
          />
        </div>
        <div class="form-group">
          <label for="lastName">Last name</label>
          <input
            type="text"
            class="form-control"
            id="lastName"
            formControlName="lastName"
          />
        </div>
        <div class="form-group">
          <label for="phone"
            >Phone
            <!-- <span class="text-danger"> *</span> -->
          </label>
          <input
            type="tel"
            class="form-control"
            id="phone"
            formControlName="phone"
          />
          <div
            *ngIf="
              registerForm.get('phone').invalid &&
              (registerForm.get('phone').dirty ||
                registerForm.get('phone').touched)
            "
            class="alert alert-danger"
          >
            <div *ngIf="registerForm.get('phone').errors?.required">
              Phone number is required.
            </div>
            <div *ngIf="registerForm.get('phone').errors?.pattern">
              Phone number must have 8 digits.
            </div>
          </div>
        </div>
        <div class="form-group" *ngIf="role == rolesEnum.Manufacturer">
          <label for="vat_num">VAT number</label>
          <input
            type="text"
            class="form-control"
            id="vat_num"
            formControlName="vat_num"
          />
        </div>
        <div class="form-group" *ngIf="role == rolesEnum.Manufacturer">
          <label for="job">Job title</label>
          <input
            type="text"
            class="form-control"
            id="job"
            formControlName="job"
          />
        </div>
        <div class="form-group" *ngIf="role == rolesEnum.Manufacturer">
          <label for="company_adress">Company address</label>
          <input
            type="text"
            class="form-control"
            id="company_adress"
            formControlName="company_adress"
          />
        </div>
        <div class="form-group" *ngIf="role == rolesEnum.HospitalStaff">
          <div class="col-3 align-items-center d-flex">
            <label for="hospitals">Hospital</label>
          </div>

          <div class="col-3 align-items-center d-flex">
            <div class="row">
              <nb-select
                disabled
                *ngIf="hospitals.length == 0"
                placeholder="No Data"
              >
              </nb-select>
              <nb-select
                id="hospitals"
                placeholder="Select hospital"
                [formControl]="selectedHospital"
                *ngIf="hospitals.length > 0"
                style="width: 20rem"
              >
                <nb-option *ngFor="let h of hospitals" value="{{ h._id }}">{{
                  h.name
                }}</nb-option>
              </nb-select>
            </div>
          </div>
        </div>

        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="registerForm.invalid"
        >
          Register
        </button>
      </form>
      <div *ngIf="error" class="mt-5">
        <div class="alert alert-danger">
          {{ error }}
        </div>
      </div>
    </nb-card-body>
  </nb-card>
</nb-auth-block>
